import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import queryString from 'query-string'

// Components
import Loader from '../utils/Loader'

// CSS
import '../../css/filebrowser.css'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

class AdminFileBrowser extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            files: [],
            errors: '',
            deleteError: '',
            requestedType: props.location.pathname === '/file-browser' ? 'file' : 'image'
        }
    }

    componentDidMount(){
        this.getFiles()
    }

    getFiles(){
        const token = this.props.user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        axios.get(REACT_APP_API_URL + `files/` + this.state.requestedType, { headers: AUTH_HEADER })
        .then(data => {
            if(data.status !== 200){
                if(data.message !== ''){
                    this.setState({ errors: data.message })
                }else{
                    this.setState({ errors: data.error })
                }
            }else{
                this.setState({ files: data.data })
            }

            this.setState({ loading: false })
        })
        .catch(err => {
            this.setState({ errors: err.message })
        })
    }

    handleSelect(file){
        // Get the CKEditorFuncNum from the url
        const query = !!this.props.location ? queryString.parse(this.props.location.search) : {}
        const funcNum = query.CKEditorFuncNum

        // Pass back the selected file and close the window
        window.opener.CKEDITOR.tools.callFunction(funcNum, file.url)
        window.close()
    }

    handleDelete(e, file){
        e.stopPropagation()

        const params = {
            name: file.name,
            type: file.type,
            requestedTypes: this.state.requestedType
        }

        this.setState({ deleteError: '' })

        const token = this.props.user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        axios.post(REACT_APP_API_URL + `files/delete`, params, { headers: AUTH_HEADER })
        .then(data => {
            if(data.data.status && data.data.status !== 200){
                if(data.message !== ''){
                    this.setState({ deleteError: data.data.message })
                }else{
                    this.setState({ deleteError: data.data.error })
                }
            }else{
                this.setState({ files: data.data })
            }
        })
        .catch(err => {
            this.setState({ deleteError: err.message })
        })
    }

    determineFileIcon(file){
        const parts = file.name.split('.')
        const ext = parts[parts.length - 1]
        if(ext === 'pdf'){
            return 'icon-file-pdf'
        }

        if(ext === 'doc' || ext === 'docx'){
            return 'icon-file-word'
        }

        if(ext === 'xls' || ext === 'xlsx'){
            return 'icon-file-excel'
        }

        return ''
    }

    render() {
        return (
            <div className="filebrowser">
                <div className="filebrowser_header">
                    <h1>File Browser</h1>
                    <div>Select an file to choose it.</div>
                </div>
                <div className="filebrowser_content">
                    {this.state.loading ? (
                        <Loader />
                    ) : (
                        this.state.errors ? (
                            <div className="error">{this.state.errors}</div>
                        ) : (
                            <div>
                                {this.state.deleteError !== '' && <div className="error msg_animate">{this.state.deleteError}</div>}

                                {this.state.files.length ? (
                                    <div className="filebrowser_wrapper">
                                        {this.state.files.map((file, i) => {
                                            return (
                                                <div className="filebrowser_file" onClick={() => this.handleSelect(file)} key={i}>
                                                    <div className="icon-cross" onClick={e => this.handleDelete(e, file)}></div>
                                                    {file.type === 'image' && <img src={file.url} alt={file.url} />}
                                                    {file.type === 'file' && <div className={'file_icon ' + (this.determineFileIcon(file))}></div> }
                                                    <div className="file_info">
                                                        {file.name}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                ) : (
                                    <div>No files uploaded yet.</div>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps)(AdminFileBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/AdminFileBrowser.js